export const ThemeValuesEnum = {
    VehicleFleetArea: 1,
    RepairableFleetArea: 2,
    PGTS: 3,
    SocialClass: 4,
    MotorcyclePartsAndWorkshop: 5,
};



// WEBPACK FOOTER //
// ./src/enuns/AfterSales/themeValues.enum.js